// extracted by mini-css-extract-plugin
export var border = "_1m-8";
export var brand = "_1m-t";
export var button = "_1m-l";
export var center = "_1m-a";
export var centered = "_1m-6";
export var closeButton = "_1m-c";
export var disabledWrapper = "_1m-m";
export var error = "_1m-p";
export var extraLarge = "_1m-4";
export var extraSmall = "_1m-1";
export var fill = "_1m-i";
export var footer = "_1m-h";
export var footerAction = "_1m-j";
export var footerButtons = "_1m-k";
export var header = "_1m-7";
export var headerWithClose = "_1m-d";
export var icon = "_1m-o";
export var info = "_1m-s";
export var inline = "_1m-9";
export var large = "_1m-3";
export var main = "_1m-e";
export var modal = "_1m-0";
export var nearFull = "_1m-5";
export var neutral = "_1m-u";
export var noPadding = "_1m-g";
export var none = "_1m-v";
export var scrollable = "_1m-f";
export var small = "_1m-2";
export var success = "_1m-r";
export var tight = "_1m-n";
export var titleIcon = "_1m-b";
export var warn = "_1m-q";